import React from 'react';
import { Link } from 'react-router-dom';
import { 
    FaTruck, FaShieldAlt, FaHeadphones, 
    FaFacebookF, FaLinkedinIn, FaTwitter, FaInstagram, 
    FaGooglePlay, FaApple, FaMapMarkerAlt, FaEnvelope, FaArrowRight 
} from 'react-icons/fa';

const B2BHaartModernFooter: React.FC = () => {
    // Theme Colors (Customizable)
    const colors = {
        bgMain: 'bg-[#0f172a]',       // Deep Slate (Official Dark)
        bgDark: 'bg-[#020617]',       // Darker shade for bottom bar
        accent: 'text-orange-500',    // TradyFrog Orange
        accentHover: 'hover:text-orange-400',
        textLight: 'text-slate-300',
        textMuted: 'text-slate-400',
        border: 'border-slate-800'
    };

    // Categories Data
    const footerLinks = {
        categories: [
            { name: "Electric Supplier", path: "/all-categories" },
            { name: "Industrial Products", path: "/all-categories" },
            { name: "Building Material", path: "/all-categories" },
            { name: "Medical Supplies", path: "/all-categories" },
            { name: "Agricultural Tools", path: "/all-categories" },
        ],
       support: [
     { name: "About Us", path: "/about" },
    { name: "Help Center", path: "/helpcenter" },
    // { name: "Shipping & Delivery", path: "/shipping" },
    // { name: "Refund & Cancellation", path: "/refund" },
    { name: "FAQs", path: "/faq" },
    { name: "Contact Us", path: "/contact" },
]

    };

    return (
        <footer className="font-sans mt-16">
            
            {/* --- 1. Trust & Benefits Bar (Official Look) --- */}
            <div className="bg-white border-b border-gray-200 py-8 shadow-sm relative z-10">
                <div className="container mx-auto px-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 text-center md:text-left">
                        
                        {/* Benefit Item 1 */}
                        <div className="flex flex-col md:flex-row items-center md:items-start space-y-2 md:space-y-0 md:space-x-4">
                            <div className="p-3 bg-orange-50 rounded-full text-orange-600">
                                <FaTruck className="text-2xl" />
                            </div>
                            <div>
                                <h4 className="font-bold text-gray-800">Pan India Delivery</h4>
                                <p className="text-sm text-gray-500">Serviceable in 20,000+ pincodes</p>
                            </div>
                        </div>

                        {/* Benefit Item 2 */}
                        <div className="flex flex-col md:flex-row items-center md:items-start space-y-2 md:space-y-0 md:space-x-4">
                            <div className="p-3 bg-blue-50 rounded-full text-blue-600">
                                <FaShieldAlt className="text-2xl" />
                            </div>
                            <div>
                                <h4 className="font-bold text-gray-800">Secure Payments</h4>
                                <p className="text-sm text-gray-500">100% Payment Protection</p>
                            </div>
                        </div>

                         {/* Benefit Item 3 */}
                         <div className="flex flex-col md:flex-row items-center md:items-start space-y-2 md:space-y-0 md:space-x-4">
                            <div className="p-3 bg-green-50 rounded-full text-green-600">
                                <FaHeadphones className="text-2xl" />
                            </div>
                            <div>
                                <h4 className="font-bold text-gray-800">24/7 Support</h4>
                                <p className="text-sm text-gray-500">Instant access to help desk</p>
                            </div>
                        </div>

                         {/* Benefit Item 4 */}
                         <div className="flex flex-col md:flex-row items-center md:items-start space-y-2 md:space-y-0 md:space-x-4">
                            <div className="p-3 bg-purple-50 rounded-full text-purple-600">
                                <FaMapMarkerAlt className="text-2xl" />
                            </div>
                            <div>
                                <h4 className="font-bold text-gray-800">Live Tracking</h4>
                                <p className="text-sm text-gray-500">Real-time order updates</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* --- 2. Main Footer Content --- */}
            <div className={`${colors.bgMain} text-white pt-16 pb-8`}>
                <div className="container mx-auto px-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
                        
                        {/* Branding & About (Span 4 cols) */}
                        <div className="lg:col-span-4 space-y-6">
                            <div className="flex items-center space-x-2">
                                {/* Logo Placeholder */}
                                {/* <div className="h-10 w-10 bg-orange-500 rounded-lg flex items-center justify-center text-white font-bold text-xl shadow-lg shadow-orange-500/30">
                                    TF
                                </div> */}
                                <h2 className="text-3xl font-bold tracking-tight">Trady<span className="text-orange-500">Frog</span></h2>
                            </div>
                            <p className={`${colors.textMuted} text-sm leading-relaxed pr-4`}>
                                India's leading B2B e-commerce platform designed for retailers and businesses. 
                                Sourcing industrial supplies, electronics, and home essentials made easy, transparent, and affordable.
                            </p>
                            
                            {/* Newsletter Input */}
                            <div className="mt-6">
                                <p className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-2">Subscribe to our offers</p>
                                <div className="flex">
                                    <input 
                                        type="email" 
                                        placeholder="Enter your email" 
                                        className="w-full px-4 py-2.5 bg-slate-800 border border-slate-700 rounded-l-lg focus:outline-none focus:border-orange-500 text-sm transition-colors"
                                    />
                                    <button className="bg-orange-600 hover:bg-orange-700 px-4 rounded-r-lg transition-colors flex items-center justify-center">
                                        <FaArrowRight />
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Quick Links (Span 2 cols) */}
                        <div className="lg:col-span-2">
                            <h3 className="text-lg font-bold mb-6 text-white border-b-2 border-orange-500 inline-block pb-1">Quick Links</h3>
                            <ul className="space-y-3 text-sm">
                                {footerLinks.support.map((link, idx) => (
                                    <li key={idx}>
                                        <Link to={link.path} className={`${colors.textLight} ${colors.accentHover} transition-all duration-300 hover:translate-x-1 inline-block`}>
                                            {link.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Top Categories (Span 3 cols) */}
                        <div className="lg:col-span-3">
                            <h3 className="text-lg font-bold mb-6 text-white border-b-2 border-orange-500 inline-block pb-1">Popular Categories</h3>
                            <ul className="space-y-3 text-sm">
                                {footerLinks.categories.map((cat, idx) => (
                                    <li key={idx}>
                                        <Link to={cat.path} className={`${colors.textLight} ${colors.accentHover} transition-all duration-300 hover:translate-x-1 inline-block`}>
                                            {cat.name}
                                        </Link>
                                    </li>
                                ))}
                                {/* <li>
                                    <Link to="/all-categories" className="text-orange-500 font-semibold text-xs uppercase tracking-wide hover:underline mt-2 inline-block">
                                        View All Categories &rarr;
                                    </Link>
                                </li> */}
                            </ul>
                        </div>

                        {/* Contact & App (Span 3 cols) */}
                        <div className="lg:col-span-3 space-y-6">
                            <div>
                                <h3 className="text-lg font-bold mb-6 text-white border-b-2 border-orange-500 inline-block pb-1">Contact Us</h3>
                                <ul className="space-y-4 text-sm text-slate-300">
                                    <li className="flex items-start space-x-3">
                                        <FaMapMarkerAlt className="text-orange-500 mt-1 flex-shrink-0" />
                                        <span>TradyFrog HQ, Okhla Phase III,<br/>New Delhi, India - 110020</span>
                                    </li>
                                    <li className="flex items-center space-x-3">
                                        <FaHeadphones className="text-orange-500 flex-shrink-0" />
                                        <span>+91 9412220200</span>
                                    </li>
                                    <li className="flex items-center space-x-3">
                                        <FaEnvelope className="text-orange-500 flex-shrink-0" />
                                        <span>info@tradyfrog.com</span>
                                    </li>
                                </ul>
                            </div>

                            {/* Socials */}
                            <div className="flex space-x-3 pt-2">
                                {[FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram].map((Icon, idx) => (
                                    <a key={idx} href="#" className="h-8 w-8 rounded bg-slate-800 flex items-center justify-center hover:bg-orange-600 hover:text-white transition-all duration-300 text-slate-400">
                                        <Icon size={14} />
                                    </a>
                                ))}
                            </div>

                             {/* App Buttons (Compact) */}
                             <div className="grid grid-cols-2 gap-2 pt-2">
                                <a href="#" className="flex items-center justify-center px-2 py-2 bg-slate-800 border border-slate-700 rounded hover:bg-slate-700 transition">
                                    <FaGooglePlay className="text-xl text-green-400 mr-2" />
                                    <div className="text-left">
                                        <p className="text-[9px] text-slate-400 leading-none">GET IT ON</p>
                                        <p className="text-[10px] font-bold text-white">Google Play</p>
                                    </div>
                                </a>
                                <a href="#" className="flex items-center justify-center px-2 py-2 bg-slate-800 border border-slate-700 rounded hover:bg-slate-700 transition">
                                    <FaApple className="text-xl text-white mr-2" />
                                    <div className="text-left">
                                        <p className="text-[9px] text-slate-400 leading-none">Download on</p>
                                        <p className="text-[10px] font-bold text-white">App Store</p>
                                    </div>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* --- 3. Bottom Copyright Bar --- */}
            <div className={`${colors.bgDark} py-6 border-t ${colors.border}`}>
                <div className="container mx-auto px-6 flex flex-col md:flex-row justify-between items-center text-xs text-slate-500">
                    
                    <div className="mb-4 md:mb-0 text-center md:text-left">
                        <p>&copy; {new Date().getFullYear()} TradyFrog. All rights reserved.</p>
                        <p className="mt-1">
                            Managed by <a href="https://nadezhda.in" target="_blank" rel="noreferrer" className="text-orange-500 hover:text-orange-400">NADEZHDA VENTURE PRIVATE LIMITED</a>
                        </p>
                    </div>

                    <div className="flex flex-wrap justify-center space-x-6">
                        <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
                        <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
                        {/* <Link to="/sitemap" className="hover:text-white transition-colors">Sitemap</Link> */}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default B2BHaartModernFooter;